<template>
  <ul class="Breadcrumbs flex lg:justify-start overflow-auto h-6">
    <li
      v-for="(breadcrumb, idx) in filteredItems"
      :key="idx"
      class="flex-self-start flex items-center relative text-sm"
      :class="idx !== filteredItems.length - 1 ? 'text-primary-1-100' : 'text-system-gray'"
    >
      <component
        :is="breadcrumb.path === $route.path || `ar/${breadcrumb.path}` === $route.path ? 'span' : 'AppLink'"
        :to="`${breadcrumb.path}`"
        class="whitespace-nowrap flex items-center"
      >
        <span>{{ breadcrumb.label }}</span>
        <span v-if="idx < filteredItems.length - 1" class="ml-1">
          <svg-icon-arrow-right
            class="w-4 h-4"
            :class="{
              'transform rotate-180': $i18n.locale === 'ar',
            }"
          />
        </span>
      </component>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { WithContext, BreadcrumbList } from 'schema-dts';

const {
  public: { appUrl },
} = useRuntimeConfig();
defineComponent({
  name: 'Breadcrumb',
});

const props = defineProps({
  items: {
    type: Array as PropType<
      {
        path: string;
        label: string;
      }[]
    >,
    required: true,
  },
});

const filteredItems = computed(() => {
  return props.items.filter(item => item.label);
});

useJsonld(
  computed<WithContext<BreadcrumbList>>(() => {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',

      itemListElement: props.items?.map((i: any, idx) => {
        return {
          '@type': 'ListItem',
          name: i.label,
          item: `${appUrl}${i.path}`,
          position: idx + 1,
        };
      }),
    };
  }).value,
);
</script>

<style lang="postcss" scoped>
.Breadcrumbs {
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
}

li {
  @apply text-current capitalize;

  &:last-child {
    @apply text-system-gray font-normal;
  }
}

li + li {
  @apply ml-2;
  /* &::before {
    @apply absolute flex items-center justify-center text-current;
    content: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 16' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9 16L1 8l8-8' stroke='#152C73' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E");
    left: -15px;
    top: 0;
    bottom: 0;
  } */

  @screen lg {
    @apply pl-0;
  }
}
</style>
